module.exports = __webpack_public_path__ + "img/e46ff25.jpg";